const actions = {
	SET_THEME: "SET_THEME"
};

export default actions;
